export enum EventActionsEnum {

  DIRECT_PAYMENT,
  ADD_TO_CART

}
